// extracted by mini-css-extract-plugin
export default {"verifyinput_wrap":"InputVerify_verifyinput_wrap__ja6pA","right_send_btn_wrap":"InputVerify_right_send_btn_wrap__8GI2Q","animate-rotate":"InputVerify_animate-rotate__y8VsZ"};